<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>委托书管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form inline :model="query" label-position="right" label-width="60px" size="small" class="query-form"
        @submit.native.prevent="getList();">
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick()">查询</el-button>
          <el-button type="success" @click="handleAdd()">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>委托书列表</span>
        </div>

        <!-- 列表 -->
        <el-table v-loading="loading" :data="tableData" ref="tableData" border stripe style="width:100%"
          @sort-chamge="sortChange" @filter-change="filterTag">
          <el-table-column prop="schName" label="学校名称"></el-table-column>
          <el-table-column label="图片预览">
            <template slot-scope="scope" width="150px">
              <img :src="domain + JSON.parse(scope.row.imgUrl).imgSmall" :style="{ height: '50px' }" alt />
            </template>
          </el-table-column>
          <el-table-column prop="viewCount" label="浏览次数"></el-table-column>
          <el-table-column prop="createTime" label="添加时间"></el-table-column>

          <!-- 操作 -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button type="primary" size="small" icon="el-icon-edit" @click="editClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button type="warning" size="small" icon="el-icon-delete" @click="delClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage4" :page-size="pageSize" :page-sizes="[10, 20, 30, 50, 100]"
            layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 弹框 -->
    <el-dialog :title="form.id > 0 ? '编辑委托书' : '添加委托书'" :visible.sync="dialogVisible" @opened="dialogOpened()">
      <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitForm(form)">

        <el-form-item label="委托书" :rules="[{ required: true, message: '不能为空' }]">
          <div class="uploader uploader-warning" id="uploadBtn2">
          </div>
          <el-image v-if="imgSmall" :src="domain + imgSmall"
            style="height:40px;position:relative;left:10px;top:20px;cursor:pointer"
            :preview-src-list="[domain + this.imgBig]">
          </el-image>
        </el-form-item>

        <el-form-item label="关联学校">
          <el-select v-model="form.schoolID" clearable filterable placeholder="请选择学校" @change="handleSchoolChange"
            style="width: 100%;">
            <el-option v-for="item in SchoolList" :label="item.name" :key="item.id" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="学校名称">
          <el-input v-model="form.schName" placeholder="请输入学校名称"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="isEnable" label="是否可用">
              <el-switch v-model="form.isEnable"></el-switch>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="排序">
              <el-input v-model="form.sort" placeholder="请输入排序号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">确定</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {},
      form: {},
      dialogVisible: false,
      loading: false,
      submiting: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1,
      imgSmall: "",
      imgBig: "",
      SchoolList:[]
    };
  },
  methods: {
    handleSizeChange: function (val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function (val) {
      this.currentPage4 = val;
      this.getList();
    },
    // 排序
    sortChange: function (sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 筛选
    filterTag: function (filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      this.getList();
    },
    handleSchoolChange(val) {
        const school = this.SchoolList.find(item => item.id === val);
        if (school) {
          this.form.schName = school.name;
        }
    },
    // 列表
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.currentPage4;
      var link = url.getVideo("GetList_Proxy");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    schoolList(){
      var _this = this;
      var link = url.getVideo("SchoolList");
      $.get(link, {}, data => {
        _this.SchoolList =data;
      });
    },
    // 查询
    selClick: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    // 处理新增按钮点击
    handleAdd() {
      this.form={
        isEnable:true
      }
      // 打开对话框
      this.dialogVisible = true;
    },
    // 编辑
    editClick: function (row) {
      var _this = this;
      _this.dialogVisible = true;
      var id = row.id;
      var link = url.getVideo("GetModel_Proxy");
      $.get(link, { id: id }, data => {
        _this.form = data;
        var img = JSON.parse(data.imgUrl);
        _this.imgSmall = img.imgSmall;
        _this.imgBig = img.imgBig;
      });
    },
    // 删除
    delClick: function (row) {
      var _this = this;
      var id = row.id;
      var link = url.getVideo("Delete_Proxy");
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link, { id: id }, res => {
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 上传
    dialogOpened: function () {
      var _this = this;
      // 大小图
      if ($("#uploadBtn2 input").length == 0) {
        $("#uploadBtn2").uploader({
          url: url.getUpload(),
          text: "上传图片",
          fileExts: "jpg;png",
          more: true, //是否可以上传多个
          auto: true, //是否自动上传simglist
          type: "imgdouble",
          minWidth: 500,
          minHeight: 500,
          maxWidth: 2000,
          maxHeight: 2000,
          handleType: "0", //对于大小图模式最好不要自动处理
          maxSize: 1024 * 1024 * 1,
          onSuccess: function (data) {
            var small = data.small;
            var big = data.big;
            // 使用 Vue 的 $nextTick 确保数据更新后视图能及时渲染
            _this.$nextTick(() => {
              _this.imgSmall = small.relativeName;
              _this.imgBig = big.relativeName;
              _this.form.imgUrl = {
                imgSmall: small.relativeName,
                imgBig: big.relativeName
              };
            });
            // //增加上传处理后台处理
            // var data = {
            //   imgSmall: small.relativeName,
            //   imgBig: big.relativeName,
            // };
            // _this.imgSmall = small.relativeName;
            // _this.imgBig = big.relativeName;
            // _this.form.imgUrl = data;
          },
        });
      }
    },
    // 提交
    submitForm: function () {
      var _this = this;
      var link = url.getVideo("Save_Proxy");
      var info = _this.form;
      if (_this.form.imgUrl == null) {
        _this.$message({
          type: "error",
          message: "请上传图片"
        });
        return;
      }
      info.imgUrl = JSON.stringify(_this.form.imgUrl);

      this.$refs.form.validate(valid => {
        if (valid) {
          _this.submiting = true;

          // 提交后台  添加或修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  mounted() {
    // 列表
    this.getList();
    this.schoolList();
  }
};
</script>